import React from 'react';
import styled from 'styled-components';

const CTA = styled.div`
  flex: 0.3;
  align-content: center;
  a {
    background: #d40f7d;
    border: none;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    color: #ffffff;
    -webkit-text-stroke-width: 1;
    -webkit-text-stroke-color: #000000;
    font-family: 'OCRoboto';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 115%;
    text-decoration: none;
  }
  @media (max-width: 600px) {
    margin: 15px;
  }
  @media (min-width: 760px) {
    a {
      font-size: 16px;
    }
  }
`;

export default ({ downloadURL }) => (
  <CTA>
    <a href={downloadURL} target="_blank" title="Download the Checklist" rel="noreferrer">
      <i className="fa fa-file-pdf-o" /> &nbsp; Download the Checklist
    </a>
  </CTA>
);
